import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "./ui/button";

const KEY = "smm_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setVisible(true);
    }, 600);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const save = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-3 left-3 right-3 md:bottom-5 md:left-5 md:right-auto md:max-w-md z-[100]"
      data-testid="cookie-banner"
    >
      <div className="bg-white border-2 border-[#1d3d3a] rounded-2xl shadow-2xl p-5 relative">
        <button
          onClick={() => save("accepted")}
          aria-label="Chiudi"
          className="absolute top-3 right-3 w-7 h-7 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-400"
          data-testid="cookie-banner-close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3">
          <div className="shrink-0 w-10 h-10 rounded-xl bg-[#faf4e8] flex items-center justify-center">
            <Cookie className="w-5 h-5 text-[#e86a24]" />
          </div>
          <div className="flex-1 min-w-0 pr-4">
            <div className="font-black text-[#1d3d3a]">Solo cookie essenziali</div>
            <p className="text-xs text-slate-600 mt-1 leading-relaxed">
              Usiamo solo cookie tecnici per farti restare loggato e ricordare le tue preferenze.
              Nessun tracciamento pubblicitario, nessun cookie di terze parti.
            </p>
            <div className="mt-3 flex flex-wrap gap-2 items-center">
              <Button
                onClick={() => save("accepted")}
                className="rounded-full bg-[#e86a24] hover:bg-[#c8561a] text-white h-9 px-4 text-xs font-bold"
                data-testid="cookie-banner-accept"
              >
                Ho capito
              </Button>
              <Link
                to="/cookie"
                onClick={() => save("seen-details")}
                className="text-xs font-semibold text-[#1d3d3a] hover:text-[#e86a24] underline underline-offset-2"
                data-testid="cookie-banner-details"
              >
                Cookie Policy
              </Link>
              <Link
                to="/privacy"
                onClick={() => save("seen-details")}
                className="text-xs font-semibold text-[#1d3d3a] hover:text-[#e86a24] underline underline-offset-2"
              >
                Privacy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
